export default __webpack_public_path__ + "static/media/main-bg.3625fee1.png";